<template>
  <div :style="{ display: block ? 'block' : 'inline-block' }">
    <slot />
    <q-tooltip
      :delay="delay"
      :anchor="currentPosition.anchor"
      :self="currentPosition.self"
      v-if="!hidden"
    >
      {{ message }}
    </q-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CTooltip',
  props: {
    message: {
      type: [String, Number],
      required: true,
    },

    position: {
      type: String,
      default: 'top',
    },

    delay: {
      type: Number,
      default: 1000,
    },

    block: {
      type: Boolean,
      default: false,
    },

    hidden: {
      type: Boolean,
    },
  },
  computed: {
    currentPosition() {
      let anchor;
      let self;

      switch (this.position) {
        case 'top':
          anchor = 'top middle';
          self = 'bottom middle';
          break;
        case 'bottom':
          anchor = 'bottom middle';
          self = 'top middle';
          break;

        case 'top close':
          anchor = 'top middle';
          self = 'center middle';
          break;

        case 'bottom close':
          anchor = 'bottom middle';
          self = 'center middle';
          break;
      }

      return { anchor: anchor, self: self };
      //
      // const positionStyle = {
      //   top: { anchor: 'top middle', self: 'bottom middle' },
      //   bottom: { anchor: 'bottom middle', self: 'top middle' },
      // };

      // if (!positionStyle[this.position]) return positionStyle['top'];
      // return positionStyle[this.position];
    },
  },
};
</script>

<style scoped></style>
